export default ".././fonts/result-403.svg";